<nb-card class="modal_medium">
  <nb-card-header class="gradient" style="padding:0.5rem 1.25rem">
    <div class="row">
      <div class=col-sm-10>
        <h6>Finance Calculator</h6>
      </div>
      <div class="col-sm-2">
        <button nbButton size="tiny" status="primary" style="float:right;margin-right: 12px;" type="button" id="close"
          name="close" (click)="ref.close(0);">
          <span class="fa fa-uncheck">&nbsp; Close</span>
        </button>
      </div>
    </div>
  </nb-card-header>
  <nb-card-body>
    <div class="row">
      <div class="col-sm-2">
        <div class="form-group">
          <label>Total Premium</label>
          <input type="text" placeholder="$0.00" [(ngModel)]="financeObject.totalPremium" class="form-control"
            id="totalPremium" name="totalPremium" currencyMask [options]="options"
            [ngClass]="{'is-invalid': errorObj && errorObj['totalPremium']}">
        </div>
      </div>
      <div class="col-sm-2">
        <div class="form-group">
          <label>Down Payment <select [(ngModel)]="financeObject.downPaymentInputType" class="df_select"
              id="downPaymentInputType" name="downPaymentInputType">
              <option [ngValue]="undefined" hidden selected> ---Choose an Option---</option>
              <option value='$'>$</option>
              <option value='%'>%</option>
            </select> </label>
          <input type="text" [(ngModel)]="financeObject.downPaymentPercentage" class="form-control"
            id="downPaymentPercentage1" name="downPaymentPercentage1" *ngIf="financeObject.downPaymentInputType =='%'"
            [ngClass]="{'is-invalid': errorObj && errorObj['downPaymentPercentage']}"currencyMask [options]="options1" >
          <input type="text" [(ngModel)]="financeObject.downPaymentPercentage" currencyMask class="form-control"
            *ngIf="financeObject.downPaymentInputType =='$'" [options]="options" id="downPaymentPercentage2"
            name="downPaymentPercentage2" [ngClass]="{'is-invalid': errorObj && errorObj['downPaymentPercentage']}"currencyMask [options]="options" >
        </div>
      </div>
      <div class="col-sm-2">
        <div class="form-group">
          <label>2 Year</label>
          <address>
            <input type="radio" id="Yes" name="yr_policy" value="Yes" [(ngModel)]="financeObject.yrPolicy">
            <label for="Yes"> &nbsp; Yes</label>
            <input style="margin-left: 12px" type="radio" id="No" name="yr_policy" value="No"
              [(ngModel)]="financeObject.yrPolicy">
            <label for="No"> &nbsp; No</label>
          </address>
        </div>
      </div>
      <!-- <div class="col-sm-3">
        <div class="form-group">
          <label>Finance (%)</label>
          <select [(ngModel)]="financeObject.apr" class="form-control">
            <option [ngValue]="undefined" hidden selected> ---Choose an Option---</option>
            <option *ngFor="let f of financeFactorList;" [value]="f.apr">
              {{f.apr}} %</option>
          </select>
        </div>
      </div> -->
      <div class="col-sm-2">
        <div class="form-group">
          <label>Installment</label>
          <address>
            <input type="radio" id="9" name="installment" value="9" [(ngModel)]="financeObject.payFactor">
            <label for="9"> &nbsp; 9</label>
            <input style="margin-left: 12px" type="radio" id="12" name="installment" value="12"
              [(ngModel)]="financeObject.payFactor">
            <label for="12"> &nbsp; 12</label>
          </address>
        </div>
      </div>
      <div class="col-sm-2">
        <button nbButton size="tiny" status="primary" style="float:left;margin-top: 18px;" type="button" id="calculate"
          name="calculate" (click)="calculate(financeObject);">
          <span class="fa fa-check">&nbsp; Calculate</span>
        </button>
      </div>
    </div>
    <div class="alert alert-danger" *ngIf="financeLimitExceed">
      <h6>Financing Limit Exceeds $100,000 </h6>
    </div>
    <div class="alert alert-success" *ngIf="checkObjectKeys(financeResultLabel)">
      <div class="row">
        <div class="col-sm-2" *ngFor="let f of financeResultLabel">
          <label style="text-transform: capitalize;font-weight: bold;">{{insertSpaces(f)}}</label>
          <h6 *ngIf="notCurrency(f)">{{financeResultObject[f]}}</h6>
          <h6 *ngIf="!notCurrency(f)">{{financeResultObject[f] | currency }}</h6>
        </div>
      </div>
    </div>

    <div class="row" id="contentBatch" *ngIf="checkObjectKeys(financeResultLabel)">
      <div class="col-sm-6">
        <table class=" table  table-bordered table-striped table-sm end">
          <thead>
            <tr>
              <th>Amount Financed</th>
              <th>APR</th>
              <th>9 Pay Factor</th>
              <th>12 Pay Factor</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let s of financeFactorList; let i=index;">
              <td [ngClass]="{'bg_color': s.factorAttains}">{{amtReceivedRegex(s.amtFinanced)}}</td>
              <td>{{s.apr}}</td>
              <td>{{s.ninePayFactor}}</td>
              <td>{{s.twelvePayFactor}}</td>
            </tr>
          </tbody>
        </table>

      </div>
    </div>
  </nb-card-body>
</nb-card>
